/**
 * Reusable page header with optional settings button
 */
import { Settings } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { haptic } from '@/shared/utils/telegram';

interface PageHeaderProps {
  title: string;
  showSettings?: boolean;
}

export function PageHeader({ title, showSettings = true }: PageHeaderProps) {
  const navigate = useNavigate();

  const handleSettingsClick = () => {
    haptic.impact('light');
    navigate('/settings');
  };

  return (
    <div className="flex items-center justify-between px-1 mb-1">
      <h1 className="text-3xl font-black uppercase tracking-tighter bg-gradient-to-br from-[var(--tg-theme-text-color)] to-[var(--tg-theme-text-color)]/70 bg-clip-text">
        {title}
      </h1>
      {showSettings && (
        <button
          onClick={handleSettingsClick}
          className="group relative p-2.5 rounded-xl bg-[var(--tg-theme-secondary-bg-color)]/60 backdrop-blur-xl border border-white/10 dark:border-white/8 hover:bg-[var(--tg-theme-secondary-bg-color)]/80 active:scale-95 transition-all duration-300 shadow-[0_2px_8px_rgba(0,0,0,0.04)]"
          aria-label="Settings"
        >
          <Settings size={18} className="text-[var(--tg-theme-hint-color)] group-hover:text-[var(--tg-theme-text-color)] transition-colors" />
        </button>
      )}
    </div>
  );
}
